// extracted by mini-css-extract-plugin
var _1 = "EmailProfileRawMessage-moduleheader__UrnVy";
var _2 = "EmailProfileRawMessage-modulemessage__kH6gp";
var _3 = "EmailProfileRawMessage-moduletext__jDljB EmailProfileRaw-moduletext__prNIu";
export { _1 as "header", _2 as "message", _3 as "text" }
